var OverdueStatus;
(function (OverdueStatus) {
    OverdueStatus[OverdueStatus["NotStarted"] = 0] = "NotStarted";
    OverdueStatus[OverdueStatus["Initial"] = 1] = "Initial";
    OverdueStatus[OverdueStatus["FetchedOverduePayments"] = 2] = "FetchedOverduePayments";
    OverdueStatus[OverdueStatus["InitiatedInstallmentPayment"] = 3] = "InitiatedInstallmentPayment";
    OverdueStatus[OverdueStatus["HandlePurchaseMethods"] = 4] = "HandlePurchaseMethods";
    OverdueStatus[OverdueStatus["Started"] = 5] = "Started";
    OverdueStatus[OverdueStatus["LackOfEligiblePaymentMethod"] = 6] = "LackOfEligiblePaymentMethod";
    OverdueStatus[OverdueStatus["Finished"] = 7] = "Finished";
})(OverdueStatus || (OverdueStatus = {}));

export { OverdueStatus };
